import { render, staticRenderFns } from "./InstanceComponent.vue?vue&type=template&id=2ac4edcb&scoped=true&"
import script from "./InstanceComponent.vue?vue&type=script&lang=js&"
export * from "./InstanceComponent.vue?vue&type=script&lang=js&"
import style0 from "./InstanceComponent.vue?vue&type=style&index=0&id=2ac4edcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4edcb",
  null
  
)

export default component.exports